export default {"src":"/_next/static/media/ic_location.5c0b595f.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};